// extracted by mini-css-extract-plugin
export var numberInputContainer = "_4c-0";
export var startPickingButton = "_4c-1";